import { UPDATE_FLIGHT_OFFERS, REMOVE_FLIGHT } from '../actions/flightOffers'
import { RESET_FLOW } from '../actions/reset'

export const initialState = {
  selectedFlights: [],
  prevSelectedFlights: '',
}

function flightOffers(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_FLIGHT_OFFERS:
      return {
        ...state,
        ...action.data,
      }
    case REMOVE_FLIGHT:
      return {
        ...state,
        selectedFlights: state.selectedFlights.map(route =>
          route.routeId === action.data.routeId
            ? {
                ...route,
                flights: route.flights.filter(
                  x => x.id !== action.data.flightId
                ),
              }
            : route
        ),
      }
    case RESET_FLOW:
      return initialState
    default:
      return state
  }
}

export default flightOffers
